import { render, staticRenderFns } from "./CategoryPropertiesAsideComponent.vue?vue&type=template&id=0fb26794&scoped=true"
import script from "./CategoryPropertiesAsideComponent.vue?vue&type=script&lang=js"
export * from "./CategoryPropertiesAsideComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb26794",
  null
  
)

export default component.exports